export default "/assets/Icon/information.svg"